export interface MFieldProps {
  label: string;
}

export const mFieldDefaults = {} satisfies Partial<MFieldProps>;
